module.exports = __webpack_public_path__ + "static/img/stereosynthese_henri_lumiere.8323c4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/stereosynthese_henri_lumiere.jpg
// module id = 38
// module chunks = 0